import React from 'react';
import { Column } from 'react-foundation';
import styled from 'styled-components';
import { getUIString } from '../../utils/helpers';
import _ from 'lodash'

interface Props {
	usage: any;
	accountType: string;
}

const SubTitle = styled.h4`
  text-align: center;
  line-height: 125%;
`;

const Costs = styled.div`
  padding-left: 3em;
  text-align: left;
  margin: auto;
  max-width: 25rem;
  list-style-type: none;
`;

export const ServiceExpenses: React.FC<Props> = (props: Props) => {
	const usage = props.usage.toJS();
	return (
		<Column large={6} small={12} centerOnLarge={props.accountType === 'consumer'}>
			<SubTitle>
				{getUIString(props.accountType, 'ServiceExpenses.header')}
			</SubTitle>
			{props.accountType === 'consumer' && (
				<Costs>
					<li>{!_.isNil(usage.analysedUsageSummary.sumVasCallsTotalVatIncluded) ? `Palvelupuhelut ${usage.analysedUsageSummary.sumVasCallsTotalVatIncluded} €` : 'Palvelupuhelut: Tietoa ei saatavilla'}</li>
					<li>{!_.isNil(usage.analysedUsageSummary.sumVasMsgTotalVatIncluded) ? `Palveluviestit ${usage.analysedUsageSummary.sumVasMsgTotalVatIncluded} €` : 'Palveluviestit: Tietoa ei saatavilla'}</li>
					<li>{!_.isNil(usage.analysedUsageSummary.sumVasAppTotalVatIncluded) ? `Sovellusostot ${usage.analysedUsageSummary.sumVasAppTotalVatIncluded} €` : 'Sovellusostot: Tietoa ei saatavilla'}</li>
					<li>{!_.isNil(usage.analysedUsageSummary.sumRoamingTotalVatIncluded) ? `Roamingmaksut ulkomailla ${usage.analysedUsageSummary.sumRoamingTotalVatIncluded} €` : 'Roamingmaksut ulkomailla: Tietoa ei saatavilla'}</li>
				</Costs>
			)}
			{props.accountType === 'business' && (
				<Costs>
					<li>{!_.isNil(usage.analysedUsageSummary.sumRoamingTotalVatExcluded) ? `Roaming ${usage.analysedUsageSummary.sumRoamingTotalVatExcluded} €` : 'Roaming: Tietoa ei saatavilla'}</li>
					<li>{!_.isNil(usage.analysedUsageSummary.sumVasTotalVatExcluded) ? `Palvelumaksut ${usage.analysedUsageSummary.sumVasTotalVatExcluded} €` : 'Palvelumaksut: Tietoa ei saatavilla'}</li>
				</Costs>
			)}
		</Column>
	)
};
